<template>
  <v-card flat class="" v-if="selectedOrder">
    <v-form ref="form" :lazy-validation="true">
      <v-row class="">
        <v-col class="">
          <v-card-title>BESTÄLLNING</v-card-title>
          <v-card-text>
            <v-row no-gutters class="" v-if="!selectedOrder.isPrintOrder">
              <v-col class="subtitle">AVSER</v-col>
              <v-col>Distansutbildning lärling</v-col>
            </v-row>
            <v-row no-gutters class="">
              <v-col class="subtitle"> Lärling </v-col>
              <v-col>
                <div v-if="selectedOrder.student">
                  <router-link :to="'/people/' + selectedOrder.student.id"
                    >{{ selectedOrder.student.firstName + ' ' + selectedOrder.student.lastName + ' (' }}
                    {{ selectedOrder.student.personalNumber | maskedPersonalNumber }} )</router-link
                  >
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="subtitle"> Arbetsgivare </v-col>
              <v-col>
                <div v-if="selectedOrder.companyId">
                  <router-link :to="'/companies/' + selectedOrder.companyId">{{
                    selectedOrder.company.name
                  }}</router-link>
                </div>
                <div>
                  {{ selectedOrder.company.postalAddress1 }}
                </div>
                <div>{{ selectedOrder.company.postalZip | formatZip }},
                {{ selectedOrder.company.postalCity }}</div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="subtitle"> Kontaktperson </v-col>
              <v-col>
                <div>
                  <router-link :to="'/people/' + selectedOrder.contactPerson.id">{{
                    selectedOrder.contactPerson.firstName + ' ' + selectedOrder.contactPerson.lastName
                  }}</router-link>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="">
              <v-col class="subtitle"> BYN-region </v-col>
              <v-col>
                {{ selectedOrder.region.name }}
              </v-col>
            </v-row>
            <v-row no-gutters class="">
              <v-col class="subtitle"> BYN-handläggare </v-col>
              <v-col>
                <div v-if="selectedOrder.createdBy">
                  <router-link :to="'/users/' + selectedOrder.createdBy.id"
                    >{{ selectedOrder.createdBy.firstName }} {{ selectedOrder.createdBy.lastName }}</router-link
                  >
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="">
              <v-col class="subtitle"> Företagets startdatum </v-col>
              <v-col>{{minDate}}</v-col>
            </v-row>
          </v-card-text>
        </v-col>
        <v-col></v-col>
      </v-row>

      <v-data-table
        v-if="!selectedOrder.isPrintOrder"
        class="mx-6"
        :headers="[{text: 'Utbildningsmoduler', value: 'orderrow'}]"
        :items="selectedOrder.distanceOrderRows"
        v-model="orderDatatable"
      >
        <template v-slot:item.orderrow="props">
          <div class="mt-1">
            <div>{{ props.item.courseCode }} {{ props.item.name }}</div>
            <div class="caption my-2" v-if="props.item.assignments && props.item.assignments.length">
              {{props.item.assignments.map(a => a.name).join(', ')}}
            </div>
          </div>
        </template>
      </v-data-table>

      <v-row no-gutters class="" v-if="!selectedOrder.isPrintOrder">
        <v-col class="">
          <v-card-text>
            <v-row no-gutters class="">
              <v-col cols="4" class="">
                <DatePicker
                  ref="startDate"
                  :disabled="selectedOrder.stateId !== paidStateId"
                  :required="true"
                  :clearable="true"
                  :minDate="minDate"
                  label="Önskat startdatum"
                  v-model="selectedOrder.educationStartDate"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-col>
      </v-row>

      <template v-if="selectedOrder.options && selectedOrder.options.books">
        <v-row no-gutters class="">
          <v-col class="">
            <v-card-title>TILLVAL</v-card-title>
            <v-card-text>
              <v-row no-gutters class="">
                <v-col class="">
                  <div>Beställda bokpaket</div>
                </v-col>
                <v-col>
                  <div>
                    <span v-if="selectedOrder.options.books == 0">Inga böcker</span>
                    <span v-if="selectedOrder.options.books == 1">Grund</span>
                    <span v-if="selectedOrder.options.books == 2">Yrke</span>
                    <span v-if="selectedOrder.options.books == 3">Grund & yrke</span>
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters class="">
                <v-col class="">
                  <div>Bokpaket skickas till</div>
                </v-col>
                <v-col>
                  <div>
                    <template v-if="selectedOrder.options.bookDeliveryAddress == 1">
                      Företaget:
                      {{ deliveryAddress }}
                    </template>
                    <template v-if="selectedOrder.options.bookDeliveryAddress == 2">
                      Lärlingen:
                      <span v-if="selectedOrder.student"
                        >{{ selectedOrder.student.firstName }} {{ selectedOrder.student.lastName }} -
                        {{ selectedOrder.student.address1 }}
                        {{ selectedOrder.student.address2 ? selectedOrder.student.address2 : '' }},
                        {{ selectedOrder.student.zip | formatZip }} {{ selectedOrder.student.city }}</span
                      >
                    </template>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
          <v-col></v-col>
        </v-row>
      </template>

      <v-card-actions class="buttons" v-if="!selectedOrder.isPrintOrder">
        <v-btn outlined @click="sendToDistanceProvider" :disabled="selectedOrder.stateId !== paidStateId || !canUpdate">
          <v-icon>mdi-file-document</v-icon>Skicka till distansutbildningsleverantör
        </v-btn>
      </v-card-actions>
      <v-card-actions class="buttons" v-else>
        <v-btn outlined @click="sendToPrintOder" :disabled="!canUpdate"> <v-icon>mdi-file-document</v-icon>Skicka till tryckeri</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import {RulesMixin, OrderingErrorHandler, CanIDo} from '@/components/mixins'
import API from '@/services/api.js'
import find from 'lodash/find'
import DatePicker from '@/components/common/DatePicker'

// @group Order
// OrderingDetail component
export default {
  name: 'OrderingDetail',

  components: {
    DatePicker
  },

  mixins: [RulesMixin, OrderingErrorHandler, CanIDo],

  data: () => ({
    menu1: false,
    minDate: '',
    orderDatatable: [],
    editing: false,
    deliveryAddress: ''
  }),

  watch: {
    selectedOrder: {
      handler: function () {
        if (this.selectedOrder && this.selectedOrder.id) {
          this.init()
        }
      },
      deep: true
    }
  },
  created() {
    if (
      this.selectedOrder &&
      this.selectedOrder.educationStartDate == null &&
      this.selectedOrder.application &&
      this.selectedOrder.application.employmentDate
    ) {
      this.selectedOrder.educationStartDate = this.$options.filters.date(this.selectedOrder.application.employmentDate)
    } else if (this.selectedOrder.educationStartDate != null) {
      this.selectedOrder.educationStartDate = this.selectedOrder.educationStartDate
    } else {
      this.selectedOrder.educationStartDate = null
    }

    if (this.selectedOrder && this.selectedOrder.educationStartDate) {
      this.minDate=this.selectedOrder.educationStartDate
    }
    this.init()
  },

  filters: {
    maskedPersonalNumber(p) {
      if (p && p.length > 8) return p.substring(0, 8) + '-****'
      else return ''
    }
  },

  computed: {
    ...mapGetters('basic', ['basicDistanceOrderStates', 'basicPrintOrderStates']),
    ...mapGetters('order', ['selectedOrder']),

    paidStateId() {
      const ps = find(this.basicDistanceOrderStates, ['state', 'paid'])
      return ps ? ps.id : -1
    },

    orderedStateId() {
      const os = find(this.basicDistanceOrderStates, ['state', 'commissioned'])
      return os ? os.id : -1
    },
    sendedToPrinterShopStateId() {
      const os = find(this.basicPrintOrderStates, ['state', 'awaitingPrint'])
      return os ? os.id : -1
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('order', 'update');
    },
  },

  methods: {
    ...mapActions('order', ['updateSelectedOrder']),

    init() {
      this.getDeliveryAddress()
    },
    getZipFormat(value){
      if (!value || value==undefined) {
        return ''
      }
      value = value.replace(' ', '')
      try {
        //value = value.replace(' ', '')
        return value.substr(0, 3) + ' ' + value.substr(3, 2)
      } catch {
        return value
      }
    },
    getDeliveryAddress() {
      if (
        this.selectedOrder &&
        this.selectedOrder.company &&
        this.selectedOrder.company.workplaces &&
        this.selectedOrder.options &&
        this.selectedOrder.options.deliveryWorkplaceId
      ) {
        const wp = find(this.selectedOrder.company.workplaces, [
          'id',
          Number(this.selectedOrder.options.deliveryWorkplaceId)
        ])
        if (wp) {
          this.deliveryAddress = `${this.selectedOrder.company.name} ${wp.postalAddress1} ${
            wp.postalAddress2 ? wp.postalAddress2 : ''
          }, ${this.getZipFormat(wp.postalZip)} ${wp.postalCity}`
        } else {
          this.deliveryAddress = '-'
        }
      } else if (
        this.selectedOrder.options &&
        this.selectedOrder.options.deliveryAddress &&
        this.selectedOrder.options.deliveryAddress.address1
      ) {
        this.deliveryAddress = `${this.selectedOrder.options.deliveryAddress.address1} ${
          this.selectedOrder.options.deliveryAddress.address2 ? this.selectedOrder.options.deliveryAddress.address2 : ''
        }, ${this.getZipFormat(this.selectedOrder.options.deliveryAddress.zip)} ${this.selectedOrder.options.deliveryAddress.city}`
      } else {
        this.deliveryAddress = '-'
      }
    },

    // @vuese
    //- Used to send to distance provider if form is valid and submited
    // @arg the argument is integer that represent selected order id

    sendToDistanceProvider() {
      if (!(this.$refs.form.validate() && this.$refs.startDate.$refs.form.validate())) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }
      if (this.selectedOrder.distanceOrderRows.length < 1 && !this.selectedOrder.isPrintOrder) {
        this.$events.fire('showError', 'Beställningen är tom, det går inte att skicka en tom beställning.')
        return
      }
      if (this.selectedOrder.orderedAt !== null) {
        this.$events.fire('showError', 'Redan beställd.')
        return
      }
      if (
        this.selectedOrder.educationStartDate <
        this.$options.filters.date(this.selectedOrder.application.employmentDate)
      ) {
        this.$events.fire('showError', 'Önskat startdatum kan inte ändras till före det startdatum satt av företag.')
        return
      }

      //- Send to distance educator
      API.updateDistanceOrder(this.selectedOrder.id,{send: true, data: this.selectedOrder})
      .then(res => {
        this.selectedOrder.orderedAt = new Date()
        this.$events.fire('showInfo', 'Beställningen skickad.')
        this.updateSelectedOrder({orderedAt: this.selectedOrder.orderedAt, stateId: this.orderedStateId, state: find(this.basicDistanceOrderStates,['state','commissioned'])})
        //this.$emit('updated')
      })
      .catch(error => {
        console.log("There was an error:", error);
        return this.handleOrderingErrors(error)
        })
    },
    async sendToPrintOder() {
      await this.updateSelectedOrder({
        orderedAt: this.selectedOrder.orderedAt,
        stateId: this.sendedToPrinterShopStateId,
        state: find(this.basicPrintOrderStates, ['state', 'awaitingPrint'])
      })

      //- Send to distance educator
      await API.updatePrintOrdersById(this.selectedOrder.id, {data: {printOrderStateId:this.selectedOrder.stateId}})
        .then(res => {
          this.selectedOrder.orderedAt = new Date()
          this.$events.fire('showInfo', 'Skickad till tryckeri .')

          //this.$emit('updated')
        })
        .catch(error => {
          console.log(error)
          this.$events.fire('showError', 'Kunde inte beställa: ' + error)
          return
        })
    }
  }
}
</script>

<style lang="scss">
.section {
  div.body-1 {
    padding-bottom: 6px;
  }
}
.buttons {
  button {
    min-width: 200px !important;
    margin-right: 10px !important;

    i {
      padding-right: 5px;
    }
  }
}
</style>
